var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveNodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white",
    fillOpacity: 0.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_6835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4482 21.7629L17.1602 18.4749L13.8721 21.7629C13.5104 22.1246 12.9186 22.1246 12.5569 21.7629C12.1952 21.4012 12.1952 20.8094 12.5569 20.4477L15.8449 17.1597L12.5569 13.8716C12.1952 13.5099 12.1952 12.9181 12.5569 12.5564C12.9186 12.1947 13.5104 12.1947 13.8721 12.5564L17.1602 15.8444L20.4482 12.5564C20.8099 12.1947 21.4017 12.1947 21.7634 12.5564C22.1251 12.9181 22.1251 13.5099 21.7634 13.8716L18.4754 17.1597L21.7634 20.4477C22.1251 20.8094 22.1251 21.4012 21.7634 21.7629C21.4017 22.1246 20.8099 22.1246 20.4482 21.7629Z",
    fill: "#2F4858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_6835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.32,
    height: 22.32,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveNodes);
export default __webpack_public_path__ + "static/media/removeNodes.16a7c72c4151d5b995f83f560a1dae6b.svg";
export { ForwardRef as ReactComponent };